<template>
  <ModalWindow
    title="Специализация"
    @close="$emit('close', $event)"
    :show-modal="showModal"
  >
    <div class="specs-modal">
      <BasicSection appearance="specs">
        <SectionGroup>
          <SpecsSelector
            :groups="groups"
            :selected-categories="selectedCategories"
            :allow-select-group="allowSelectGroup"
            :category-field-name="categoryFieldName"
            :user-categories-data="userCategoriesData"
            :max-selected-categories-count="maxSelectedCategoriesCount"
            :has-been-closed="!showModal"
            @update:data="onUpdateData"
          />

          <div>
            <ButtonGroup appearance="inline">
              <BasicButton
                type="button"
                appearance="primary"
                size="l"
                @click="selectCategories"
              >
                Применить
              </BasicButton>
              <BasicButton
                v-if="canReset"
                appearance="secondary"
                size="l"
                @click="reset"
              >
                Сбросить фильтр
              </BasicButton>
            </ButtonGroup>
          </div>
        </SectionGroup>
      </BasicSection>
    </div>
  </ModalWindow>
</template>

<script>
import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import ButtonGroup from 'src/components/ButtonGroup/ButtonGroup.vue';
import ModalWindow from 'src/components/overlays/ModalWindow/ModalWindow.vue';
import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
import SpecsSelector from 'src/components/SpecsSelector/SpecsSelector.vue';

export default {
  name: 'SpecsModal',
  components: {
    SectionGroup,
    BasicButton,
    ButtonGroup,
    SpecsSelector,
    BasicSection,
    ModalWindow,
  },
  props: {
    groups: {
      type: Array,
      required: true,
    },
    maxSelectedCategoriesCount: {
      type: Number,
      default: 1,
    },
    canReset: {
      type: Boolean,
      default: true,
    },
    allowSelectGroup: {
      type: Boolean,
      default: true,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    categoryFieldName: {
      type: String,
      default: 'sc',
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    userCategoriesData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:data', 'close'],
  data() {
    return {
      specsSelected: this.selectedCategories,
    };
  },
  methods: {
    selectCategories(event) {
      this.resetUnusedTextFields();
      this.$emit('update:data', this.specsSelected);
      this.$emit('close', event);
    },
    reset(event) {
      this.resetUnusedTextFields();
      this.$emit('update:data', []);
      this.$emit('close', event);
    },
    resetUnusedTextFields() {
      Object.keys(this.userCategoriesData).forEach((categoryId) => {
        if (!this.specsSelected.includes(+categoryId)) {
          this.userCategoriesData[categoryId] = '';
        }
      });
    },
    onUpdateData(data) {
      this.specsSelected = data.specs.selectedCategories;
    },
  },
};
</script>
